var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 119,
    height: 135,
    viewBox: "0 0 119 135",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-27 -10)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.01,
    cy: 83.8,
    fill: "#F1F4F4",
    rx: 47.877,
    ry: 47.757
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#BECACF",
    strokeWidth: 0.6,
    d: "M98.069 29.91c-29.671-7.95-60.153 9.598-68.083 39.195-7.93 29.596 9.693 60.034 39.364 67.984 29.67 7.95 60.153-9.597 68.083-39.194"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#BECACF",
    strokeWidth: 0.6,
    d: "M53.21 136.327c29.248 16.886 66.614 6.924 83.458-22.251 16.845-29.175 6.79-66.516-22.46-83.403C84.96 13.787 47.596 23.75 30.75 52.924"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#002842",
    strokeWidth: 1.2,
    d: "M58.019 121.647a1.8 1.8 0 0 0-1.8 1.8v.804a1.8 1.8 0 0 0 1.8 1.8h9.245a1.8 1.8 0 0 0 1.8-1.8v-.804a1.8 1.8 0 0 0-1.8-1.8H58.02zM101.84 121.647a1.8 1.8 0 0 0-1.8 1.8v.804a1.8 1.8 0 0 0 1.8 1.8h9.245a1.8 1.8 0 0 0 1.8-1.8v-.804a1.8 1.8 0 0 0-1.8-1.8h-9.245z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#002842",
    strokeWidth: 1.2,
    d: "M116.231 42.03H51.75c-4.378 0-7.928 3.541-7.928 7.909v64.32c0 4.368 3.55 7.909 7.928 7.909h64.482c4.379 0 7.928-3.541 7.928-7.909V49.94c0-4.368-3.55-7.909-7.928-7.909z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1D9DE",
    fillOpacity: 0,
    stroke: "#CDD5DA",
    strokeWidth: 1.2,
    d: "M55.619 53.799h57.304v57.16H55.62z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#002842",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M84.271 98.07c8.689 0 15.73-7.15 15.73-15.97 0-8.821-7.041-15.972-15.73-15.972-8.688 0-15.73 7.15-15.73 15.972 0 8.82 7.042 15.97 15.73 15.97z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.552 90.225c4.499 0 8.146-3.638 8.146-8.126 0-4.489-3.647-8.126-8.146-8.126-4.499 0-8.146 3.637-8.146 8.126 0 4.488 3.647 8.126 8.146 8.126zM84.271 94.708v2.802M84.271 66.128v2.802M84.271 66.688v2.802M84.271 94.708v2.802M99.44 81.819h-2.81M71.35 81.819h-2.81M96.069 71.171l-2.809 2.802M74.72 90.785l-1.685 1.681M73.035 71.171l2.809 2.802M93.26 90.785l1.685 1.681"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FF0049",
    d: "M98.316 41.47v-5.884c0-1.083.817-1.962 1.827-1.962h3.652c1.008 0 1.825.879 1.825 1.962v5.884"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#002842",
    d: "M82.024 33.624v7.846"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FF0049",
    d: "M70.079 35.305H66.44c-1.011 0-1.832-.92-1.832-2.054v-8.22c0-1.134.82-2.054 1.832-2.054h3.639c1.013 0 1.832.92 1.832 2.054v8.22c0 1.134-.819 2.054-1.832 2.054zM91.99 25.218h-3.64c-1.013 0-1.832-.92-1.832-2.055v-8.219c0-1.134.82-2.055 1.833-2.055h3.639c1.01 0 1.832.92 1.832 2.055v8.22c0 1.134-.821 2.054-1.832 2.054z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#002842",
    d: "M54.495 10.648v14.57M113.485 14.01v14.57"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#002B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M139.114 91.24c0-1.614-1.41-2.934-3.132-2.934h-25.654c-1.722 0-3.132 1.32-3.132 2.935V110c0 1.614 1.41 2.934 3.132 2.934h25.654c1.722 0 3.132-1.32 3.132-2.935V91.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#787C7F",
    d: "M123.155 100.551c-1.164 0-2.108-.996-2.108-2.218 0-1.229.944-2.218 2.108-2.218 1.164 0 2.108.99 2.108 2.218 0 1.222-.944 2.218-2.108 2.218z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#787C7F",
    strokeLinejoin: "round",
    strokeWidth: 1.44,
    d: "M123.155 99.072v6.655"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#002B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M112.616 81.999c0-5.476 4.583-9.913 10.239-9.913 5.655 0 10.237 4.437 10.237 9.913v6.307h-20.476v-6.307z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3);
export default __webpack_public_path__ + "static/media/group-3.1fe52c65445984a6ce8175abd4c16175.svg";
export { ForwardRef as ReactComponent };